import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    EmvioValidatedInput,
    EmvioValidatedButton,
    EmvioValidatedForm
} from '@nexio/emvio-form-components';
import { Link } from 'react-router-dom';
import '../Login.scss';
import './LoginForm.scss';

export default class Form extends Component {
    static propTypes = {
        email: PropTypes.string,
        isLoading: PropTypes.bool,
        onForgotPassword: PropTypes.func,
        onLogin: PropTypes.func,
        onUpdateEmail: PropTypes.func,
        wasAccountCreatedSuccessfully: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            password: ''
        };
    }

    updatePassword(e) {
        this.setState({
            password: e.target.value
        });
    }

    render() {
        const env = process.env.BUILD_ENV === 'production' ? '' : 'non-prod';

        return (
            <div>
                <div className="subtitle">
                    {
                        env === 'non-prod' ? (
                            'Sign in to your Nexio Sandbox account'
                        ) : (
                            'Sign in to your Nexio account'
                        )
                    }
                </div>
                { this.props.wasAccountCreatedSuccessfully ? (
                    <div className="login-subheader">Please check your email for a temporary password</div>
                ) : null }
                <EmvioValidatedForm onSubmit={this.props.onLogin(this.props.email, this.state.password)}>
                    <div className="login-row">
                        <EmvioValidatedInput
                            autoCapitalize="off"
                            autoCorrect="off"
                            autoFocus
                            labelText="Email"
                            name="email"
                            onChange={this.props.onUpdateEmail}
                            placeholder="Email"
                            shouldEnforceLowerCase={true}
                            type="text"
                            validations={['email', 'required']}
                            value={this.props.email}
                        />
                    </div>
                    <div className="login-row">
                        <EmvioValidatedInput
                            inputWrapperClassName="password-input"
                            labelText="Password"
                            name="password"
                            onChange={this.updatePassword.bind(this)}
                            placeholder="Password"
                            type="password"
                            validations={['required']}
                            value={this.state.password}
                        />
                    </div>
                    <EmvioValidatedButton isLoading={this.props.isLoading}>
                        SIGN IN
                    </EmvioValidatedButton>
                    <div className="sub-link">
                        <a href="#" onClick={this.props.onForgotPassword}>Forgot Password</a>
                    </div>
                    <div>
                        { env !== 'non-prod' || this.props.wasAccountCreatedSuccessfully ? (null) : (
                            <div>
                                <span className="login-or"><hr className="login-split"/>OR<hr className="login-split"/></span>
                                <span className="signup-link-container">Don&apos;t have a Sandbox account?<Link to="/signup" className="signup-link">Get started today</Link></span>
                            </div>
                        ) }
                    </div>
                </EmvioValidatedForm>
            </div>
        );
    }
}
